import { render } from "./Home.vue?vue&type=template&id=0c2bb49f&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=0c2bb49f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c2bb49f"

export default script